import type { accountData, secuencyData } from "./types";
import heritageCharData from "../../data/heritageCharData.json";

export class heritageChartService {
  async getHeritageData(clientId: number): Promise<accountData[]> {
    const heritageData = heritageCharData.data.filter(
      (heritage: any) => heritage.clientId === clientId
    );
    
    // Transformar los datos para que coincidan con el tipo accountData
    return heritageData.map((heritage: any) => ({
      id: heritage.id,
      accountNumber: heritage.accountNumber,
      secuency: heritage.secuency?.secuency?.map((desc: string, index: number) => ({
        id: index + 1,
        description: desc,
        first: desc === heritage.secuency?.firstSecuency
      })) || [],
      heritageTotal: heritage.heritageTotal,
      chart: heritage.chart || []
    }));
  }

  async getHeritageById(accountId: number): Promise<accountData | null> {
    const heritage = heritageCharData.data.find(
      (heritage: any) => heritage.id === accountId
    );
    
    if (!heritage) return null;
    
    // Transformar los datos para que coincidan con el tipo accountData
    return {
      id: heritage.id,
      accountNumber: heritage.accountNumber,
      secuency: heritage.secuency?.secuency?.map((desc: string, index: number) => ({
        id: index + 1,
        description: desc,
        first: desc === heritage.secuency?.firstSecuency
      })) || [],
      heritageTotal: heritage.heritageTotal,
      chart: heritage.chart || []
    };
  }

  async getFirstHeritage(clientId: number): Promise<accountData | null> {
    const heritage = heritageCharData.data.find(
      (heritage: any) => heritage.clientId === clientId
    );
    
    if (!heritage) return null;
    
    // Transformar los datos para que coincidan con el tipo accountData
    return {
      id: heritage.id,
      accountNumber: heritage.accountNumber,
      secuency: heritage.secuency?.secuency?.map((desc: string, index: number) => ({
        id: index + 1,
        description: desc,
        first: desc === heritage.secuency?.firstSecuency
      })) || [],
      heritageTotal: heritage.heritageTotal,
      chart: heritage.chart || []
    };
  }
}